<template>
    <div>
        <div v-if="substituteGroups.active" class="tab-section-active">
            <div class="matrix-panel">
                <div class="table-layout">
                    <div class="table-head head-fixed">
                        <div class="table-tr">
                            <div class="table-th cell-word-review">{{ __('[coach availability] Date') }}</div>
                            <div class="table-th cell-duration">{{ __('Length') }}</div>
                            <div class="table-th cell-patient">{{ __('Substitutes for') }}</div>
                        </div>
                    </div>

                    <div class="table-body">
                        <SubstituteRow
                            v-for="substitute in substituteGroups.active"
                            :key="substitute.id"
                            :substitute="substitute"
                            class="active-vacation"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div v-if="substituteGroups.future" class="tab-section-future">
            <h3 class="tab-subtitle">{{ __('Upcoming substitutions') }}</h3>

            <div class="matrix-panel">
                <div class="table-layout">
                    <div class="table-head head-fixed">
                        <div class="table-tr">
                            <div class="table-th cell-word-review">{{ __('[coach availability] Date') }}</div>
                            <div class="table-th cell-duration">{{ __('Length') }}</div>
                            <div class="table-th cell-patient">{{ __('Substitutes for') }}</div>
                        </div>
                    </div>

                    <div class="table-body">
                        <SubstituteRow
                            v-for="substitute in substituteGroups.future"
                            :key="substitute.id"
                            :substitute="substitute"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div v-if="substituteGroups.past" class="tab-section-past">
            <h3 class="tab-subtitle">{{ __('Past substitutions') }}</h3>

            <div class="matrix-panel">
                <div class="table-layout">
                    <div class="table-head head-fixed">
                        <div class="table-tr">
                            <div class="table-th cell-word-review">{{ __('[coach availability] Date') }}</div>
                            <div class="table-th cell-duration">{{ __('Length') }}</div>
                            <div class="table-th cell-patient">{{ __('Substitutes for') }}</div>
                        </div>
                    </div>

                    <div class="table-body">
                        <SubstituteRow
                            v-for="substitute in substituteGroups.past"
                            :key="substitute.id"
                            :substitute="substitute"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div v-if="loading" class="loader-wrapper">
            <img src="/imgs/vitadio-loader.svg" alt="">
        </div>

        <div v-else-if="substituteGroups.length === 0" class="no-data">
            <figure>
                <svg-icon icon="icon-no-data"></svg-icon>
            </figure>
            <p>{{ __("No records") }}</p>
        </div>
    </div>
</template>

<script>
import SubstituteRow from './SubstituteRow'

export default {
    components: {
        SubstituteRow
    },
    props: {
        coach: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showCreateForm: false,
            substituteGroups: [],
            loading: true
        }
    },
    watch: {
        async '$parent.tab'(tab) {
            if (tab === 'substitute') {
                this.substituteGroups = await this.fetch()

                this.loading = false
            }
        }
    },
    methods: {
        fetch() {
            return axios.get(`/coaches/${this.coach.id}/substitutes`).then((r) => r.data.data)
        }
    }
}
</script>
